import React from 'react';
import './NotionDataTable.css';

const TableExpensive = ({ data, properties, formatValue }) => {
  return (
    <div className="table-wrapper">
      <table className="notion-data-table">
        <thead>
          <tr>
            <th className="sticky-col">№</th>
            {properties.map((prop) => (
              <th key={prop}>{prop}</th>
            ))}
            <th>Создано</th>
            <th>Изменено</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={row.id}>
              <td className="sticky-col">{index + 1}</td>
              {properties.map((prop) => (
                <td key={prop}>{formatValue(row[prop])}</td>
              ))}
              <td className="date-cell">
                {new Date(row.created_time).toLocaleDateString('ru-RU')}
              </td>
              <td className="date-cell">
                {new Date(row.last_edited_time).toLocaleDateString('ru-RU')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableExpensive;

